import React, { useState, useEffect, Component, useCallback } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import { DocumentTypeRule } from "../../../models";
import AttorneySelect from "../../../components/shared/AttorneySelect";
import { DataService } from "../../../services/DataService";
import MessageRuleTestModal from "./../../../pages/queue/components/modals/MessageRuleTestModal";
import { Button, Row } from "react-bootstrap";
import { FileService } from "../../../services/SubmissionService";
import { responsiveFontSizes } from "@material-ui/core";
import { JPLocationData } from "../../../models/swagger/generated-data-service";

export default function JusticeOfPeaceLocator() {
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("TX");
    const [zip, setZip] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [csvErrorMessage, setCsvErrorMessage] = useState("");
    const [csvFile, setCsvFile] = useState<File>();
    const [isHeaders, setIsHeaders] = useState(false);
    const [jPPrecinct, setJPPrecinct] = useState("");
    const [isCsvLoading, setIsCsvLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [jPData, setJPData] = useState(new JPLocationData());

    const onSearchCSV = () => {
        setCsvErrorMessage("");
        setIsCsvLoading(true);
        if (csvFile) {
            DataService.getJPCSV({
                file: csvFile,
                headers: isHeaders,
            }).then(
                (resp) => {
                    setIsCsvLoading(false);
                    const url = URL.createObjectURL(new Blob([resp]));

                    fetch(url).then((response) => {
                        response.blob().then((blob) => {
                            // Creating new object of PDF file
                            const fileURL = window.URL.createObjectURL(blob);
                            // Setting various property values
                            const alink = document.createElement("a");
                            alink.href = fileURL;
                            alink.download =
                                csvFile!.name.split(".csv")[0] + "_JP.csv";
                            alink.click();
                        });
                    });
                },

                (error) => {
                    //input.value = "";
                    setIsCsvLoading(false);
                    console.log(error);
                    setCsvErrorMessage(error.message);
                }
            );
        }
    };

    const onFileUpload = (event: React.FormEvent) => {
        event.preventDefault();

        const input = event.target as HTMLInputElement;

        if (!input.files?.length) {
            return;
        }

        setCsvFile(input.files[0]);
    };

    const onSearch = (event: { preventDefault: () => void }) => {
        event.preventDefault();

        //setJPData(new JPLocationData());
        setJPPrecinct("");
        setErrorMessage("");
        setIsLoading(true);
        DataService.getJP({
            address: address + " " + city + " " + state + " " + zip,
        }).then(
            (resp) => {
                if (resp.successful) {
                    setIsLoading(false);
                    //setJPData(resp.data!);
                    setJPPrecinct(
                        resp.data?.county +
                            " " +
                            resp.data?.officE1 +
                            " " +
                            resp.data?.precinct
                    );
                } else {
                    setErrorMessage("Error");
                    setIsLoading(false);
                }
            },
            (error) => {
                //input.value = "";
                console.log(error);
                setIsLoading(false);
            }
        );
    };

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">
                                Justice of Peace Precint Locator
                            </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Tools</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Justice of Peace Precint Locator
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="card text-center">
                            <div className="card-body">
                                <h4 className="header-title">
                                    Justice of Peace Precint Locator
                                </h4>
                                <p>
                                    This is a tool designed to locate which
                                    Justice of Peace Precint a given address is
                                    located.
                                </p>
                                <p>
                                    You can either upload a CSV with multiple
                                    addresses or enter a single address.
                                </p>

                                <div
                                    id="checkout-nav-pills-wizard"
                                    className="twitter-bs-wizard form-wizard-header"
                                >
                                    <div
                                        className="col-sm-2"
                                        style={{ display: "inline-block" }}
                                        /*
                                        style={{
                                            position: "relative",
                                            top: "50%",
                                            left: "40%",
                                        }}
                                        */
                                    >
                                        <ul className="nav nav-pills navtab-bg nav-justified">
                                            <li className="nav-item">
                                                <a
                                                    href="#csv-info"
                                                    className="nav-link text-center active"
                                                    data-bs-toggle="tab"
                                                    data-toggle="tab"
                                                >
                                                    <span className="d-none d-sm-inline">
                                                        CSV
                                                    </span>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    href="#address-info"
                                                    className="nav-link text-center"
                                                    data-bs-toggle="tab"
                                                    data-toggle="tab"
                                                >
                                                    <span className="d-none d-sm-inline">
                                                        Address
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div>
                                        <div className="card-body">
                                            <div className="tab-content twitter-bs-wizard-tab-content">
                                                <div
                                                    className="tab-pane active"
                                                    id="csv-info"
                                                >
                                                    <p className="mb-3">
                                                        <b>
                                                            Please attach an CSV
                                                            file with the
                                                            addresses you want
                                                            to lookup. (Format:
                                                            address, city,
                                                            state, zip)
                                                        </b>
                                                    </p>
                                                    <form
                                                        //className="needs-validation"
                                                        onSubmit={(event) =>
                                                            onFileUpload(event)
                                                        }
                                                    >
                                                        {" "}
                                                        <div className="row">
                                                            <div
                                                                className="col"
                                                                style={{
                                                                    position:
                                                                        "relative",
                                                                    top: "50%",
                                                                    left: "25%",
                                                                }}
                                                            >
                                                                <div className="col-md-6">
                                                                    <div className="input-group">
                                                                        <input
                                                                            type="file"
                                                                            accept=".csv"
                                                                            className="form-control"
                                                                            id="example-fileinput"
                                                                            onChange={(
                                                                                event
                                                                            ) =>
                                                                                onFileUpload(
                                                                                    event
                                                                                )
                                                                            }
                                                                            required={
                                                                                true
                                                                            }
                                                                        />{" "}
                                                                        {isCsvLoading ? (
                                                                            <button
                                                                                className="btn btn-primary"
                                                                                //type="submit"

                                                                                style={{
                                                                                    display:
                                                                                        "inline-block",
                                                                                }}
                                                                                disabled={
                                                                                    true
                                                                                }
                                                                                /*
                                                                            style={{
                                                                                right: 24,
                                                                                bottom: 40,
                                                                                position:
                                                                                    "absolute",
                                                                            }}
                                                                            */

                                                                                onClick={
                                                                                    onSearchCSV
                                                                                }
                                                                            >
                                                                                <span
                                                                                    className="spinner-border spinner-border-sm"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                ></span>
                                                                                <span className="visually-hidden">
                                                                                    {" "}
                                                                                    Search
                                                                                </span>
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                className="btn btn-primary"
                                                                                //type="submit"

                                                                                style={{
                                                                                    display:
                                                                                        "inline-block",
                                                                                }}
                                                                                /*
                                                                            style={{
                                                                                right: 24,
                                                                                bottom: 40,
                                                                                position:
                                                                                    "absolute",
                                                                            }}
                                                                            */

                                                                                onClick={
                                                                                    onSearchCSV
                                                                                }
                                                                            >
                                                                                <span className="">
                                                                                    {" "}
                                                                                    Search
                                                                                </span>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        color: "red",
                                                                    }}
                                                                >
                                                                    {
                                                                        csvErrorMessage
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-checkinput"
                                                                    id="chkHeaders"
                                                                    readOnly={
                                                                        true
                                                                    }
                                                                    onClick={(
                                                                        event
                                                                    ) =>
                                                                        setIsHeaders(
                                                                            !isHeaders
                                                                        )
                                                                    }
                                                                    checked={
                                                                        isHeaders
                                                                    }
                                                                />

                                                                <label className="form-check-label">
                                                                    <h6 className="ps-1">
                                                                        Does
                                                                        first
                                                                        row
                                                                        contain
                                                                        column
                                                                        names?
                                                                    </h6>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>

                                                <div
                                                    className="tab-pane text-center"
                                                    id="address-info"
                                                >
                                                    <div className="">
                                                        <div className="card-body text-top">
                                                            <p
                                                                className="mb-3"
                                                                style={{
                                                                    position:
                                                                        "relative",
                                                                    top: "50%",
                                                                    left: "1%",
                                                                }}
                                                            >
                                                                <b>
                                                                    Please enter
                                                                    the address
                                                                    you want to
                                                                    search.
                                                                </b>
                                                            </p>
                                                            <form
                                                                //className="needs-validation"
                                                                onSubmit={
                                                                    onSearch
                                                                }
                                                                style={{
                                                                    position:
                                                                        "relative",
                                                                    top: "50%",
                                                                    left: "31%",
                                                                }}
                                                            >
                                                                <div className="row mb-3">
                                                                    <div className="col-sm-4">
                                                                        {" "}
                                                                        <div className="input-group">
                                                                            <label
                                                                                htmlFor="inputEmail3"
                                                                                className="col-sm-3 col-form-label"
                                                                            >
                                                                                Street
                                                                                Address
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                required
                                                                                className="form-control"
                                                                                id="txtAddress"
                                                                                //placeholder="Street Address"
                                                                                aria-describedby="inputGroupPrepend"
                                                                                value={
                                                                                    address
                                                                                }
                                                                                onChange={(
                                                                                    event
                                                                                ) =>
                                                                                    setAddress(
                                                                                        event
                                                                                            .currentTarget
                                                                                            .value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-sm-4">
                                                                        <div className="input-group">
                                                                            {" "}
                                                                            <label
                                                                                htmlFor="txtProfileMiddleName"
                                                                                className="col-sm-3 col-form-label"
                                                                            >
                                                                                City
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                required
                                                                                id="txtProfileMiddleName"
                                                                                //placeholder="Middle Name"
                                                                                aria-describedby="inputGroupPrepend"
                                                                                value={
                                                                                    city
                                                                                }
                                                                                onChange={(
                                                                                    event
                                                                                ) =>
                                                                                    setCity(
                                                                                        event
                                                                                            .currentTarget
                                                                                            .value
                                                                                    )
                                                                                }
                                                                            />
                                                                            <div className="invalid-feedback">
                                                                                Please
                                                                                provide
                                                                                a
                                                                                valid
                                                                                middle
                                                                                name.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-sm-4">
                                                                        <div className="input-group">
                                                                            <label
                                                                                htmlFor="txtProfileLastName"
                                                                                className="col-sm-3 col-form-label"
                                                                            >
                                                                                State
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                required
                                                                                id="txtProfileLastName"
                                                                                placeholder="TX"
                                                                                aria-describedby="inputGroupPrepend"
                                                                                disabled
                                                                                value={
                                                                                    state
                                                                                }
                                                                                onChange={(
                                                                                    event
                                                                                ) =>
                                                                                    setState(
                                                                                        event
                                                                                            .currentTarget
                                                                                            .value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-3">
                                                                    <div className="col-sm-4">
                                                                        <div className="input-group">
                                                                            <label
                                                                                htmlFor="txtProfileLastName"
                                                                                className="col-sm-3 col-form-label"
                                                                            >
                                                                                Zip
                                                                                Code
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                required
                                                                                id="txtProfileLastName"
                                                                                //placeholder="Last Name"
                                                                                aria-describedby="inputGroupPrepend"
                                                                                value={
                                                                                    zip
                                                                                }
                                                                                onChange={(
                                                                                    event
                                                                                ) =>
                                                                                    setZip(
                                                                                        event
                                                                                            .currentTarget
                                                                                            .value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="row mt-3">
                                                                    <div
                                                                        className="col-8"
                                                                        style={{
                                                                            textAlign:
                                                                                "center",
                                                                        }}
                                                                    >
                                                                        {isLoading ? (
                                                                            <button
                                                                                className="btn btn-primary mb-3"
                                                                                //type="submit"

                                                                                style={{
                                                                                    display:
                                                                                        "inline-block",
                                                                                }}
                                                                                disabled={
                                                                                    true
                                                                                }
                                                                                /*
                                                                            style={{
                                                                                right: 24,
                                                                                bottom: 40,
                                                                                position:
                                                                                    "absolute",
                                                                            }}
                                                                            */
                                                                            >
                                                                                <span
                                                                                    className="spinner-border spinner-border-sm"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                ></span>
                                                                                <span className="visually-hidden">
                                                                                    {" "}
                                                                                    Search
                                                                                </span>
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                className="btn btn-primary mb-3"
                                                                                //type="submit"

                                                                                style={{
                                                                                    display:
                                                                                        "inline-block",
                                                                                }}
                                                                                /*
                                                                            style={{
                                                                                right: 24,
                                                                                bottom: 40,
                                                                                position:
                                                                                    "absolute",
                                                                            }}
                                                                            */
                                                                            >
                                                                                <span className="">
                                                                                    {" "}
                                                                                    Search
                                                                                </span>
                                                                            </button>
                                                                        )}

                                                                        <div
                                                                            style={{
                                                                                color: "red",
                                                                            }}
                                                                        >
                                                                            {
                                                                                errorMessage
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                            <div
                                                                className="row mb-3"
                                                                style={{
                                                                    position:
                                                                        "relative",
                                                                    top: "50%",
                                                                    left: "31%",
                                                                }}
                                                            >
                                                                {" "}
                                                                {jPPrecinct ==
                                                                    "" ||
                                                                jPPrecinct ==
                                                                    undefined ||
                                                                jPPrecinct ==
                                                                    null ? (
                                                                    <></>
                                                                ) : (
                                                                    <div className="col-sm-4">
                                                                        <div className="input-group">
                                                                            <label
                                                                                htmlFor="txtProfileFirstName"
                                                                                className="col-sm-3 col-form-label"
                                                                            >
                                                                                Justice
                                                                                of
                                                                                Peace
                                                                                Precint
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                required
                                                                                className="form-control"
                                                                                id="txtProfileFirstName"
                                                                                // placeholder="Firstname"
                                                                                aria-describedby="inputGroupPrepend"
                                                                                value={
                                                                                    jPPrecinct
                                                                                }
                                                                            />
                                                                            <div className="invalid-feedback">
                                                                                Please
                                                                                provide
                                                                                a
                                                                                valid
                                                                                first
                                                                                name.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
